export const ADD_PROJETO = 'ADD_PROJETO'
export const EDIT_PROJETO = 'EDIT_PROJETO'
export const DELETE_PROJETO = 'DELETE_PROJETO'
export const DEFINE_PROJETOS = 'DEFINE_PROJETOS'

export const NOTIFICAR = 'NOTIFICAR'


export const  DEFINE_TAREFAS = 'DEFINE_TAREFAS' 
export const  ADD_TAREFA = 'ADD_TAREFA' 
export const  EDIT_TAREFA = 'EDIT_TAREFA' 